/** @format */
import { getConfig } from '@toucan/common/services/nextjs/settings';

import { Market } from '@toucan/client/global/market';

export const getHelpCentreUrl = (
    market: Market,
    isConsolidatedIntercomConfigActive: boolean = false
) => {
    const { publicRuntimeConfig } = getConfig();

    if (
        isConsolidatedIntercomConfigActive &&
        publicRuntimeConfig?.intercomConsolidatedLink
    ) {
        const baseUrl = new URL(
            market.language,
            // Want to ensure this ends with a single trailing slash
            `${publicRuntimeConfig.intercomConsolidatedLink}/`.replace(
                /\/{2,}$/,
                '/'
            )
        );
        return baseUrl.href;
    }

    return publicRuntimeConfig?.intercomLinks?.[market.code] ?? '';
};
